import { el } from 'redom';

import { stringToSVG } from 'utilities';

import dialogCloseButtonIconString from 'assets/images/dialog-close-button-icon.svg?raw';

const dialogCloseButtonIcon = stringToSVG(dialogCloseButtonIconString);

class DialogCloseButton {

  constructor(configuration) {

    this.onClick = configuration.onClick;
    this.el = el('button', {
      type: 'button',
      class: 'dialog-close-button',
      onclick: this.handleClickEvent.bind(this)
    }, [dialogCloseButtonIcon.cloneNode(true)]);

  }

  async handleClickEvent() {

    this.onClick();

  }

}

export default DialogCloseButton;